import { NotifyError } from '../boot/Notify'

export default function (e) {
  console.error(e)
  NotifyError('Um erro interno ocorreu')
}
